document.addEventListener('DOMContentLoaded', () => {

  /* ============================================================
     HERO SLIDESHOW
  ============================================================ */
  const slides = document.querySelectorAll('.hero-slide');
  const dotsWrap = document.querySelector('.hero-dots');
  const counterCurrent = document.querySelector('.hero-counter-current');
  const heroSection = document.querySelector('.hero');
  let cur = 0;
  let heroTimer;

  if (slides.length) {
    const updateSlide = (i) => {
      slides[cur].classList.remove('active');
      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll('button');
        if (dots[cur]) dots[cur].classList.remove('active');
      }
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('active');
      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll('button');
        if (dots[cur]) dots[cur].classList.add('active');
      }
      if (counterCurrent) {
        counterCurrent.textContent = String(cur + 1).padStart(2, '0');
      }
      resetHeroTimer();
    };

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.setAttribute('aria-label', `Slide ${i + 1}`);
        if (i === 0) b.classList.add('active');
        b.addEventListener('click', () => updateSlide(i));
        dotsWrap.appendChild(b);
      });
    }

    const nextBtn = document.querySelector('.hero-next');
    const prevBtn = document.querySelector('.hero-prev');
    if (nextBtn) nextBtn.addEventListener('click', () => updateSlide(cur + 1));
    if (prevBtn) prevBtn.addEventListener('click', () => updateSlide(cur - 1));

    const speed = heroSection && heroSection.dataset.speed ? Number(heroSection.dataset.speed) * 1000 : 6000;
    const isAutoplay = heroSection ? heroSection.dataset.autoplay !== 'false' : true;

    function playHero() {
      if (isAutoplay && slides.length > 1) {
        heroTimer = setInterval(() => updateSlide(cur + 1), speed);
      }
    }
    function resetHeroTimer() {
      if (heroTimer) clearInterval(heroTimer);
      playHero();
    }
    playHero();

    // Touch Swipe for mobile hero
    let touchStartX = 0;
    let touchEndX = 0;
    if (heroSection) {
      heroSection.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      heroSection.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) updateSlide(cur + 1);
        if (touchEndX - touchStartX > 50) updateSlide(cur - 1);
      }, { passive: true });
    }
  }

  /* ============================================================
     "MOST LOVED" CATEGORY TABS
  ============================================================ */
  const mostLovedTabs = document.querySelectorAll('.most-loved-tab');
  const mostLovedPanels = document.querySelectorAll('.most-loved-tab-panel');

  if (mostLovedTabs.length && mostLovedPanels.length) {
    mostLovedTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const idx = tab.dataset.tabIndex;
        mostLovedTabs.forEach((t) => t.classList.remove('active'));
        mostLovedPanels.forEach((p) => p.classList.remove('active'));
        tab.classList.add('active');
        const targetPanel = document.querySelector(`.most-loved-tab-panel[data-panel-index="${idx}"]`);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

  /* ============================================================
     OLFACTORY NOTES PYRAMID TABS
  ============================================================ */
  const olfactoryTabs = document.querySelectorAll('.olfactory-tab');
  const olfactoryPanels = document.querySelectorAll('.olfactory-panel');

  if (olfactoryTabs.length && olfactoryPanels.length) {
    olfactoryTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const scentId = tab.dataset.scentTab;
        olfactoryTabs.forEach((t) => t.classList.remove('active'));
        olfactoryPanels.forEach((p) => p.classList.remove('active'));
        tab.classList.add('active');
        const targetPanel = document.querySelector(`.olfactory-panel[data-scent-panel="${scentId}"]`);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

  /* ============================================================
     EXCLUSIVE OFFERS — COPY PROMO CODE
  ============================================================ */
  document.querySelectorAll('[data-copy-code]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const code = btn.dataset.copyCode;
      if (!code) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const temp = document.createElement('input');
          temp.value = code;
          document.body.appendChild(temp);
          temp.select();
          document.execCommand('copy');
          document.body.removeChild(temp);
        }
        btn.classList.add('copied');
        setTimeout(() => btn.classList.remove('copied'), 2000);
      } catch (err) {
        console.warn('Copy failed:', err);
      }
    });
  });

  /* ============================================================
     LUXURY ADD TO BAG FORM
     ------------------------------------------------------------
     No handler here on purpose. The grid forms in
     sections/scent-bestsellers.liquid also carry
     .scentimental-add-to-cart-form, so cart.js owns the submit:
     it adds the line, re-fetches /cart.js, re-renders the drawer
     and only then opens it. A second listener here would add the
     item twice and open a drawer rendered from the stale cart.
  ============================================================ */

  /* ============================================================
     REELS AUDIO & TRACK CONTROLS
  ============================================================ */
  /* Scoped per slider, not per page. This used to be three
     document.querySelector calls, which bind only the FIRST track and the
     FIRST pair of arrows in the document — so on any page carrying two
     reels sections the second one's arrows did nothing, and the first
     one's arrows scrolled a track the visitor might not even be looking
     at. The step also hardcoded the 20px flex gap, which is 14px under
     600px, so mobile paging drifted out of alignment with the cards.
     Both are read from the DOM now. */
  document.querySelectorAll('.reels-slider-wrap').forEach((wrap) => {
    const track = wrap.querySelector('.reels-track');
    if (!track) return;

    const step = () => {
      const card = track.querySelector('.reel-card');
      if (!card) return 280;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.offsetWidth + gap;
    };

    const prev = wrap.querySelector('.reels-prev');
    const next = wrap.querySelector('.reels-next');

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

    /* Disable an arrow when the track cannot travel further, rather than
       leaving a live-looking control that does nothing at either end. */
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    };

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  document.querySelectorAll('.reel-mute').forEach((btn) => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.reel-card');
      if (!card) return;
      const video = card.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      const iconMute = btn.querySelector('.icon-mute');
      const iconSound = btn.querySelector('.icon-sound');
      if (iconMute && iconSound) {
        iconMute.style.display = video.muted ? 'block' : 'none';
        iconSound.style.display = video.muted ? 'none' : 'block';
      }
      // The label was a static "Toggle Sound", so a screen reader never
      // learned whether the reel was currently muted or playing audio.
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      if (!video.muted) video.play();
    });
  });

  /* ============================================================
     MAGNETIC BUTTONS (desktop only)
  ============================================================ */
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('.btn-fill, .hero-cta, .reel-shop, .add-btn').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${x * 0.18}px, ${y * 0.22}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ============================================================
     CUSTOM CURSOR (desktop only)
  ============================================================ */
  const cursor = document.querySelector('.cursor');
  if (cursor && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    let mx = 0, my = 0, cx = 0, cy = 0;
    window.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });
    (function loop() {
      cx += (mx - cx) * 0.18;
      cy += (my - cy) * 0.18;
      cursor.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll('a, button, .pcard, .reel-card, .fp-box').forEach((el) => {
      el.addEventListener('mouseenter', () => cursor.classList.add('big'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('big'));
    });
  }

  /* ============================================================
     BACK TO TOP
  ============================================================ */
  const toTop = document.querySelector('.to-top');
  if (toTop) {
    window.addEventListener('scroll', () => toTop.classList.toggle('show', window.scrollY > 600));
    toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ============================================================
     GENERIC DRAWER SYSTEM — Collection filter drawer ONLY.
     The cart drawer (#scentimental-cart-drawer) is intentionally
     excluded here — it is owned entirely by cart.js so there is
     exactly one place handling cart open/close, no duplicate
     listeners, no double-fetches.
  ============================================================ */
  const getDrawerById = (id) => (id ? document.getElementById(id) : null);

  const getDrawerFromElement = (element) => {
    const drawerId = element.dataset.drawerToggle || element.dataset.drawerClose;
    if (drawerId) return getDrawerById(drawerId);
    return element.closest('.collection-filter-drawer');
  };

  const setDrawerBackdrop = (drawer, visible) => {
    if (!drawer) return;
    let backdrop = drawer.querySelector('.collection-filter-backdrop');
    if (!backdrop && drawer.id) {
      backdrop = document.querySelector(`[data-drawer-close="${drawer.id}"].collection-filter-backdrop`);
    }
    if (!backdrop) return;
    backdrop.classList.toggle('is-visible', visible);
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    drawer.classList.add('is-visible');
    setDrawerBackdrop(drawer, true);
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
    setDrawerBackdrop(drawer, false);
  };

  document.querySelectorAll('[data-drawer-toggle]').forEach((button) => {
    if (button.dataset.drawerToggle === 'scentimental-cart-drawer') return; // cart.js owns this
    const drawer = getDrawerById(button.dataset.drawerToggle);
    if (!drawer) return;
    button.addEventListener('click', () => openDrawer(drawer));
  });

  document.querySelectorAll('[data-drawer-close]').forEach((button) => {
    if (button.closest('.scentimental-cart-drawer')) return; // cart.js owns this
    const drawer = getDrawerById(button.dataset.drawerClose) || getDrawerFromElement(button);
    if (!drawer) return;
    button.addEventListener('click', () => closeDrawer(drawer));
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.matches('.collection-filter-backdrop')) {
      closeDrawer(getDrawerFromElement(target));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.collection-filter-drawer.is-visible')
        .forEach((drawer) => closeDrawer(drawer));
    }
  });

  /* ============================================================
     WISHLIST
  ============================================================ */
  const wishlistKey = 'scentimental-wishlist';
  const recentlyViewedKey = 'scentimental-recently-viewed';

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (items) => localStorage.setItem(wishlistKey, JSON.stringify(items));

  const updateWishlistUI = () => {
    const list = document.getElementById('scentimental-wishlist-list');
    const counts = document.querySelectorAll('.wishlist-count');
    const items = getWishlist();
    counts.forEach((count) => { count.textContent = items.length; });
    if (!list) return;
    if (!items.length) {
      list.innerHTML = '<div class="page-card">Your wishlist is empty. Save a product to view it here.</div>';
      return;
    }
    list.innerHTML = items.map((item) => `
      <article class="scentimental-wishlist-card">
        <div class="scentimental-wishlist-media" style="background-image:url('${item.image || ''}')"></div>
        <div class="scentimental-wishlist-body">
          <h3>${item.title}</h3>
          <p>${item.price || ''}</p>
          <div class="scentimental-wishlist-actions">
            <a href="/products/${item.handle}" class="btn-fill">View product</a>
            <button class="btn-outline" type="button" data-wishlist-remove data-product-id="${item.id}">Remove</button>
          </div>
        </div>
      </article>
    `).join('');
  };

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      const product = {
        id: wishlistButton.getAttribute('data-product-id'),
        title: wishlistButton.getAttribute('data-product-title'),
        handle: wishlistButton.getAttribute('data-product-handle'),
        image: wishlistButton.getAttribute('data-product-image'),
        price: wishlistButton.getAttribute('data-product-price')
      };
      const items = getWishlist();
      const exists = items.some((item) => item.id === product.id);
      const next = exists ? items.filter((item) => item.id !== product.id) : [...items, product];
      saveWishlist(next);
      wishlistButton.textContent = exists ? 'Add to wishlist' : 'Added';
      updateWishlistUI();
      return;
    }

    const wishlistRemoveButton = event.target.closest('[data-wishlist-remove]');
    if (wishlistRemoveButton) {
      event.preventDefault();
      const productId = wishlistRemoveButton.getAttribute('data-product-id');
      const next = getWishlist().filter((item) => item.id !== productId);
      saveWishlist(next);
      updateWishlistUI();
    }
  });

  /* ============================================================
     TABS / COPY BUTTONS

     Variant switching and the PDP quantity box used to live here.
     They now live in scentimental-pdp.js, which scopes its lookups
     to the page rather than to the <form> — the old version scoped
     them to the form, so the gallery image and the headline price
     (both of which sit outside the form) were never found, and the
     resulting TypeError killed the selected-state toggle on the
     line after it. Do not reintroduce a variant handler here.
  ============================================================ */

  document.querySelectorAll('.scentimental-product-tabs').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('.scentimental-tab-toggle');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('active'));
        tabs.querySelectorAll('.scentimental-tab-panel').forEach((panel) => panel.classList.remove('is-open'));
        button.classList.add('active');
        const panel = tabs.querySelector(`[data-panel="${button.getAttribute('data-tab')}"]`);
        if (panel) panel.classList.add('is-open');
      });
    });
    if (buttons.length) buttons[0].click();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.scentimental-copy-btn, .oc-copy-btn');
    if (!button) return;

    const code = button.getAttribute('data-code') || button.textContent;
    const original = button.textContent;

    try {
      await navigator.clipboard.writeText(code);
      button.textContent = 'Copied';
      button.classList.add('copied');
      setTimeout(() => {
        button.textContent = original;
        button.classList.remove('copied');
      }, 1400);
    } catch (error) {
      button.textContent = 'Copy failed';
      setTimeout(() => { button.textContent = original; }, 1400);
    }
  });

  /* ============================================================
     RECENTLY VIEWED
  ============================================================ */
  const recentlyViewed = document.querySelector('[data-recently-viewed-container]');
  const recentlyViewedProduct = document.querySelector('[data-recently-viewed-product]');
  if (recentlyViewed && recentlyViewedProduct) {
    const currentProduct = {
      id: recentlyViewedProduct.getAttribute('data-product-id'),
      title: recentlyViewedProduct.getAttribute('data-product-title'),
      handle: recentlyViewedProduct.getAttribute('data-product-handle'),
      image: recentlyViewedProduct.getAttribute('data-product-image'),
      price: recentlyViewedProduct.getAttribute('data-product-price'),
      rating: recentlyViewedProduct.getAttribute('data-product-rating'),
      ratingCount: recentlyViewedProduct.getAttribute('data-product-rating-count')
    };

    // these values are interpolated into innerHTML below, and they come back
    // out of localStorage as plain text — an apostrophe in a product title
    // would otherwise break out of the alt attribute
    const esc = (value) => String(value == null ? '' : value).replace(
      /[&<>"']/g,
      (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char])
    );

    // entries stored before the rating was captured simply have no rating,
    // so the row hides itself rather than rendering "undefined"
    const ratingRow = (item) => {
      const rating = parseFloat(item.rating);
      if (!rating) return '';
      const count = parseInt(item.ratingCount, 10);
      return `
          <p class="scentimental-card-rating">
            <span class="scentimental-card-star" aria-hidden="true">★</span>
            <span>${rating.toFixed(1)}</span>
            ${count ? `<span class="scentimental-card-rating-count">(${count})</span>` : ''}
          </p>`;
    };

    const stored = JSON.parse(localStorage.getItem(recentlyViewedKey) || '[]');
    const filtered = stored.filter((item) => item.id !== currentProduct.id);
    filtered.unshift(currentProduct);
    const trimmed = filtered.slice(0, 8);
    localStorage.setItem(recentlyViewedKey, JSON.stringify(trimmed));

    recentlyViewed.innerHTML = trimmed.map((product) => `
      <article class="scentimental-card">
        <a href="/products/${esc(product.handle)}" class="scentimental-card-media">
          <img src="${esc(product.image)}" alt="${esc(product.title)}">
          <span class="scentimental-card-badge">Bestseller</span>
        </a>
        <div class="scentimental-card-body">
          <h3>${esc(product.title)}</h3>
          <p class="scentimental-card-subtitle">Fine fragrance body lotion</p>
          ${ratingRow(product)}
          <div class="scentimental-card-actions">
            <a href="/products/${esc(product.handle)}" class="add-btn">ADD ~ ${esc(product.price)}</a>
          </div>
        </div>
      </article>
    `).join('');
  }

  /* ============================================================
     BEST-SELLER MARQUEE — drag to scroll
  ============================================================ */
  const marquee = document.querySelector('.bs-marquee');
  const track = document.querySelector('.bs-track');

  if (marquee && track) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    marquee.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('dragging');
      startX = e.pageX;
      scrollLeft = marquee.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('dragging');
    });

    marquee.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const walk = (e.pageX - startX) * 2;
      marquee.scrollLeft = scrollLeft - walk;
    });

    marquee.addEventListener('touchstart', (e) => {
      track.classList.add('dragging');
      startX = e.touches[0].pageX;
      scrollLeft = marquee.scrollLeft;
    });

    marquee.addEventListener('touchmove', (e) => {
      const walk = (e.touches[0].pageX - startX) * 2;
      marquee.scrollLeft = scrollLeft - walk;
    });

    marquee.addEventListener('touchend', () => track.classList.remove('dragging'));
  }

  /* ============================================================
     PRODUCT GALLERY — click thumbnails + swipe main image
  ============================================================ */
  const mainImage = document.getElementById('scentimental-main-image');
  const thumbs = [...document.querySelectorAll('.pdp-thumb')];

  if (mainImage && thumbs.length) {
    let current = 0;

    function showImage(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      current = index;
      thumbs.forEach((t) => t.classList.remove('active'));
      thumbs[current].classList.add('active');
      mainImage.style.backgroundImage = `url('${thumbs[current].dataset.image}')`;
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));

    if (thumbs.length > 1) {
      let startX = 0, dragging = false;

      const swipeStart = (x) => { dragging = true; startX = x; };
      const swipeEnd = (x) => {
        if (!dragging) return;
        dragging = false;
        const distance = x - startX;
        if (Math.abs(distance) < 40) return;
        showImage(distance < 0 ? current + 1 : current - 1);
      };

      mainImage.addEventListener('touchstart', (e) => swipeStart(e.touches[0].clientX), { passive: true });
      mainImage.addEventListener('touchend', (e) => swipeEnd(e.changedTouches[0].clientX));
      mainImage.addEventListener('mousedown', (e) => swipeStart(e.clientX));
      window.addEventListener('mouseup', (e) => swipeEnd(e.clientX));
    }
  }

  /* ============================================================
     RECENTLY VIEWED SLIDER — loop + drag (desktop only)
  ============================================================ */
  const rvRow = document.querySelector('.scentimental-recently-viewed-row');
  const rvPrev = document.querySelector('.scentimental-rv-prev');
  const rvNext = document.querySelector('.scentimental-rv-next');

  if (rvRow) {
    const getRvCardWidth = () => {
      const card = rvRow.querySelector('.scentimental-card');
      return card ? card.offsetWidth + 16 : 0;
    };

    const rvScrollNext = () => {
      const max = rvRow.scrollWidth - rvRow.clientWidth;
      if (rvRow.scrollLeft >= max - 5) {
        rvRow.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        rvRow.scrollBy({ left: getRvCardWidth(), behavior: 'smooth' });
      }
    };

    const rvScrollPrev = () => {
      if (rvRow.scrollLeft <= 5) {
        rvRow.scrollTo({ left: rvRow.scrollWidth, behavior: 'smooth' });
      } else {
        rvRow.scrollBy({ left: -getRvCardWidth(), behavior: 'smooth' });
      }
    };

    if (rvNext) rvNext.addEventListener('click', rvScrollNext);
    if (rvPrev) rvPrev.addEventListener('click', rvScrollPrev);

    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      let rvIsDown = false;
      let rvStartX = 0;
      let rvScrollLeft = 0;

      rvRow.addEventListener('mousedown', (e) => {
        rvIsDown = true;
        rvRow.classList.add('dragging');
        rvStartX = e.pageX;
        rvScrollLeft = rvRow.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        rvIsDown = false;
        rvRow.classList.remove('dragging');
      });

      rvRow.addEventListener('mouseleave', () => {
        rvIsDown = false;
        rvRow.classList.remove('dragging');
      });

      rvRow.addEventListener('mousemove', (e) => {
        if (!rvIsDown) return;
        e.preventDefault();
        const walk = (e.pageX - rvStartX) * 1.4;
        rvRow.scrollLeft = rvScrollLeft - walk;
      });
    }
  }

  /* ============================================================
     HIDE STICKY ADD-TO-CART BAR WHEN FOOTER IS IN VIEW
  ============================================================ */
  const stickyBar = document.querySelector('.pdp-sticky-actions');
  const siteFooter = document.querySelector('.footer');

  if (stickyBar && siteFooter && 'IntersectionObserver' in window) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyBar.classList.toggle('is-hidden', entry.isIntersecting);
      });
    }, { threshold: 0 });

    footerObserver.observe(siteFooter);
  }

  /* ============================================================
     SCROLL REVEAL (INTERSECTION OBSERVER)
  ============================================================ */
  const revealElements = document.querySelectorAll('.reveal, .reveal-stagger, .feat-img-wrap, .video-block, .bs-marquee, .foot-mark');

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -20px 0px',
      threshold: 0.05
    });

    revealElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('in');
      } else {
        revealObserver.observe(el);
      }
    });
  } else {
    revealElements.forEach((el) => el.classList.add('in'));
  }

  /* ============================================================
     INITIAL RENDER
  ============================================================ */
  updateWishlistUI();

});

/* ============================================================
   FIXED HEADER HEIGHT  +  SEAMLESS OFFER-BAR MARQUEE
   ------------------------------------------------------------
   The offer bar and header are position:fixed (custom.css), so their
   height has to be handed back to the layout as a number. --scent-head-h
   drives #MainContent's top padding and the full-screen hero's height.

   The marquee loops by translating the track exactly one .offer-group
   width, which is seamless by construction. Enough groups are cloned to
   cover the viewport plus one spare, otherwise the track runs out of
   content before the animation restarts — that was the visible gap at
   the ends of the old translateX(-50%) version.
============================================================ */
(function () {
  'use strict';

  var PX_PER_SECOND = 60;

  function measureHeader() {
    var bar = document.getElementById('shopify-section-scent-offer-bar');
    var head = document.getElementById('shopify-section-scent-header');
    var barH = bar ? bar.getBoundingClientRect().height : 0;
    var h = barH + (head ? head.getBoundingClientRect().height : 0);

    // The header is fixed and has to sit exactly on top of the bar. This used
    // to be a hardcoded 34px in custom.css, so any change to the bar's height
    // — a message wrapping on a narrow screen, an extra announcement, a
    // padding tweak — left the header overlapping it. Publish the real number.
    // Set even when barH is 0: the section renders nothing when the merchant
    // has no announcements configured, and the header must then sit flush at
    // the top rather than below the 34px CSS fallback gap.
    if (bar) {
      document.documentElement.style.setProperty('--scent-bar-h', Math.round(barH) + 'px');
    }

    if (!h) return;

    document.documentElement.style.setProperty('--scent-head-h', Math.round(h) + 'px');
  }

  function initMarquee() {
    var tracks = document.querySelectorAll('.offer-bar .offer-track');

    Array.prototype.forEach.call(tracks, function (track) {
      var first = track.querySelector('.offer-group');
      if (!first) return;

      // Drop clones from a previous run so a resize re-measures cleanly.
      Array.prototype.forEach.call(
        track.querySelectorAll('.offer-group[data-offer-clone]'),
        function (node) { node.remove(); }
      );

      var groupWidth = first.getBoundingClientRect().width;
      var bar = track.parentElement;
      var viewport = bar.getBoundingClientRect().width;
      if (!groupWidth || !viewport) return;

      // Scroll only when there is something to scroll to. With three short
      // messages the whole set fits a desktop viewport with room to spare,
      // and a marquee that never needed to move is the loudest thing a
      // header can do. `Always scroll` in the section settings opts out.
      var staticFits = bar.classList.contains('offer-bar--auto') && groupWidth <= viewport - 48;
      bar.classList.toggle('is-static', staticFits);
      if (staticFits) {
        track.style.removeProperty('--offer-shift');
        track.style.removeProperty('--offer-dur');
        return;
      }

      var needed = Math.ceil(viewport / groupWidth) + 1;
      for (var i = 1; i < needed; i++) {
        var copy = first.cloneNode(true);
        copy.setAttribute('data-offer-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      }

      track.style.setProperty('--offer-shift', groupWidth + 'px');
      track.style.setProperty('--offer-dur', Math.max(8, groupWidth / PX_PER_SECOND) + 's');
    });
  }

  function sync() {
    measureHeader();
    initMarquee();
  }

  function boot() {
    sync();
    // Web fonts land after DOMContentLoaded and change both measurements.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Width only: on mobile the address bar hiding fires a resize on every
  // scroll, and re-syncing there would restart the marquee mid-loop.
  var resizeTimer = null;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 200);
  });

  document.addEventListener('shopify:section:load', sync);
})();

/* ============================================================
   MOBILE MENU DRAWER
   ------------------------------------------------------------
   The burger button in sections/scent-header.liquid had no click
   handler anywhere in the theme. custom.css carried the comment
   "(active version — matches theme.js)", but layout/theme.liquid
   loads only custom.js, cart.js and scent-home.js — Ella's theme.js
   is never loaded, and its only mobile-menu code is for a different
   component ([data-mobile-menu-tab]) in any case.

   Below 760px .nav-links is display:none, so with a dead burger the
   site had no navigation on a phone at all: no menu, and no route to
   the in-drawer search either. This is that handler.
============================================================ */
(function () {
  'use strict';

  var drawer = document.getElementById('mobile-menu-drawer');
  var opener = document.querySelector('[data-mobile-open]');
  if (!drawer || !opener) return;

  var panel = drawer.querySelector('.mobile-menu-panel');
  var lastFocus = null;

  function isOpen() {
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    opener.setAttribute('aria-label', 'Close menu');
    document.body.classList.add('overflow-hidden');

    // Focus the close button rather than the panel, so the first Tab lands
    // on the search field and the drawer is operable from the keyboard.
    var close = drawer.querySelector('.mobile-menu-close');
    if (close) close.focus();
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    opener.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('overflow-hidden');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  opener.addEventListener('click', function () {
    if (isOpen()) { close(); } else { open(); }
  });

  // Backdrop and the × both carry data-mobile-close. Delegated, so the
  // handler survives a section re-render in the theme editor.
  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-close]')) close();
  });

  // Navigating away should not leave the drawer open behind the new page
  // on a bfcache restore.
  drawer.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (link && panel && panel.contains(link)) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close();
  });

  // Keep the tab ring inside the panel while it is open.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !isOpen() || !panel) return;

    var focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Crossing back to desktop with the drawer open would otherwise leave the
  // body scroll-locked against a menu that is no longer visible.
  window.addEventListener('resize', function () {
    if (window.innerWidth > 760 && isOpen()) close();
  });
})();
